import isEmpty from 'lodash/isEmpty';
import { isOptionChecked } from './processOptionsUtils';
import { PROCESS_OPTIONS_TRACKING_MAP as MAP, PROCESS_OPTIONS_TRACKING_HIERARCHY as HIERARCHY } from './AlertCreateDialogConstatns';

function _generateBasic({ databases, basicContentDatabases }) {
  const basicChecked = basicContentDatabases && basicContentDatabases.filter((o) => isOptionChecked(o.value, databases));

  return !isEmpty(basicChecked) && `Basic alert content:${basicChecked.map((o) => o.label).join(';')}`;
}

function _generateAdvanced({ advancedContentDatabase }) {
  return `Advanced Alert content:${advancedContentDatabase.label}-${advancedContentDatabase.checked ? 'on' : 'off'}`;
}

function _generateOptions({ advancedContentDatabase, processOptions }) {
  return (
    advancedContentDatabase.checked &&
    HIERARCHY.map((h) => {
      const { value, children } = h;
      const checkedChildren = children && children.filter((c) => isOptionChecked(c, processOptions));

      let str = `${MAP[value]}:${isOptionChecked(value, processOptions) ? 'on' : 'off'}`;

      if (!isEmpty(checkedChildren)) {
        str += `;${checkedChildren.map((c) => MAP[c]).join(';')}`;
      }

      return str;
    })
  );
}

export function defineAlertDetails(props) {
  const { databases, processOptions, basicContentDatabases, advancedContentDatabase } = props;

  const basic = _generateBasic({ databases, basicContentDatabases });
  const advanced = _generateAdvanced({ advancedContentDatabase });
  const options = _generateOptions({ advancedContentDatabase, processOptions });

  return [basic, advanced, ...(options || [])].filter((v) => v).join('|');
}

export function defineAlertFrequency(props) {
  const { frequency, dayOfWeek, dayOfMonth } = props;
  return [frequency, dayOfMonth, dayOfWeek].filter((v) => v).join(';');
}
